/*
 * ChallengeQuestionForm Messages
 *
 * This contains all the text for the ChallengeQuestionForm component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.ChallengeQuestionForm";

export default defineMessages(scope, {
  createYourAccount: "Let’s create your account.",
  header: "Welcome to Envestnet",
  emailLabel: "Your Email",
  questionLabel: "What is the street name of your firm?",
  submitButtonLabel: "Submit",
  errorChallengeQuestion2:
    "Invalid input. 2 attempts remaining before account is locked.",
  errorChallengeQuestion1:
    "Invalid input. 1 attempt remaining before account is locked.",
  emailErrorHint: "Please enter a valid email address",
});
